import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { AddressWarningItemMaintenanceDto } from './AddressWarningItemMaintenanceDto';
import { AddressWarningListMaintenanceDto } from './AddressWarningListMaintenanceDto';
import { WarningCustomCodeDto } from '@shared/src/dtos/warning/WarningCustomCodeDto';
import { Observable } from 'rxjs-compat';

@Injectable()
export class AddressWarningSubMaintenanceController extends BaseSubMaintenanceController<AddressWarningListMaintenanceDto, AddressWarningItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {
        super(http, alertService, translateService, loadingService, router, "address/warning");
    }

    public getResourceRoot(): string {
        return "WARNING";
    }
    public getWarningCustomCode(parentId: number, addresswarningid: number): Observable<WarningCustomCodeDto> {
        return this.get(this.getBaseUrl(parentId) + "/code/" + addresswarningid);
    }

    public compileCode(parentId: number,data: WarningCustomCodeDto): Observable<WarningCustomCodeDto> {
        return this.post(this.getBaseUrl(parentId) + "/compilecode", data, "compileCode");
    }

    public saveCode(parentId: number, data: WarningCustomCodeDto): Observable<WarningCustomCodeDto> {
        return this.post(this.getBaseUrl(parentId) + "/savecode", data, "saveCode");
    }


    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/activity/address/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}
